import {useQuery} from '@tanstack/react-query'
import React, {useEffect} from 'react'
import {QueryCacheKeys} from '../../QueryKey'
import {getLeaderDetail} from '../../../apis/leader/getLeaderDetail'

const useQueryLeaderDetail = (id?: string) => {
    const {data, refetch, isLoading} = useQuery({
        queryKey: QueryCacheKeys.copyTrading.getLeaderDetail(id),
        queryFn: async () => {
            const {data} = await getLeaderDetail(id)
            return data
        },
        refetchOnWindowFocus: false,
    })

    useEffect(() => {
        refetch()
    }, [])

    return {data, refetch, isLoading}
}

export default useQueryLeaderDetail
